<template>
  <chart-card v-if="ready"
        :chart-data="dailySalesChart.data"
        :chart-options="dailySalesChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="blue"
        header-animation="false">
        <template slot="content">
        </template>
    </chart-card>
</template>

<script>
import ChartCard from '@/components/Crops/ChartCard'

export default {
  name: 'graph-card',
  props: ['data', 'headers'],
  components: { ChartCard },
  data() {
    return {
      dailySalesChart: null,
      ready: false
    }
  },
  watch: {
    data() {
      this.generateChart();
    }
  },
  mounted() {
    this.generateChart();
  },
  methods: {
    formatHeader(index) {
      let partial = this.headers[index].replace(/_/g,' ');
      return partial.charAt(0).toUpperCase() + partial.slice(1) ;
    },
    getData(index){ return (this.data[index]) ? this.data[index] : 0; },
    generateChart() {
      this.dailySalesChart = null;
      this.ready = false;
      this.dailySalesChart = {
        data: {
          labels: [this.formatHeader(12), this.formatHeader(13), this.formatHeader(14), this.formatHeader(15)],
          series: [
            [this.getData(this.headers[12]), this.getData(this.headers[14]), this.getData(this.headers[14]), this.getData(this.headers[15])]
          ]
        },
        options: {
          height:'110px',
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,

          }),
          low: this.getData(this.headers[11]),
          high: this.getData(this.headers[10]), // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 15,
            right: 0,
            bottom: -10,
            left: 0
          },
          axisY: {
            labelInterpolationFnc: function(value) {
              return value+'%'
            },
            offset: 50
          },
        }
      }
      this.$nextTick(function () {
        this.ready = true;
      })
    }
  }
}

</script>
